<template>
  <div>
    <v-wait :for="waiterKeyword">
      <template slot="waiting">
        <div class="container loader">
          <div class="row justify-content-md-center">
            <div class="col-md-auto">
              <spinner></spinner>
            </div>
          </div>
        </div>
      </template>
      <validation-observer v-slot="{handleSubmit}" ref="formValidator">
        <form class="needs-validation"
              @submit.prevent="handleSubmit(formSubmit)">
          <div class="form-row">
            <div class="col-md-8">
              <base-input
                type="text"
                v-model="model.title"
                rules="required|max:250"
                :label="$t('Lesson title')"
                :name="$t('Lesson title')"
                labelClasses="required form-control-label"
              >
              </base-input>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-8">
              <base-input
                :name="$t('Video')"
                :label="$t('Video')"
              >
                <el-select
                  v-model="model.videoId"
                  class="select-primary"
                  :placeholder="$t('Choose video')"
                  required>
                  <el-option v-for="option in videos"
                             class="select-primary"
                             :key="option.id"
                             :value="option.id"
                             :label="`${option.fileName} (${option.size})`">
                  </el-option>
                  <el-option class="select-primary"
                             :key="-1"
                             :value="undefined"
                             :label="$t('---')">
                  </el-option>
                </el-select>
              </base-input>
            </div>
            <div class="col-md-4">
              <base-button @click="showVideosPicker = true" class="btn-default mt-4">
                VideoPicker
              </base-button>
              <modal-videos-picker
                v-model="showVideosPicker"
                @onCancel="showVideosPicker = !showVideosPicker"
                @onPickVideo="videoPicked"
                :videos="videos">
              </modal-videos-picker>
            </div>
          </div>
          <div class="my-3">
            <tabs tabNavClasses="nav-fill nav-wrapper"
                tabContentClass="card"
            >
              <tab-pane id="markdown-editor">
                <div slot="title">
                  <i class="ni ni-pencil"></i>
                  {{ $t('Editor') }}
                </div>
               <textarea
                  class="form-control"
                  rows="10"
                  v-model="model.body">
                </textarea>
              </tab-pane>
              <tab-pane id="markdown-preview">
                <div @click="loadPreview" slot="title">
                  <i class="ni ni-eye"></i>
                  {{ $t('Preview') }}
                </div>
                <markdown-preview
                  :show-button="false"
                  ref="preview"
                  :value="model.body">
                </markdown-preview>
              </tab-pane>
            </tabs>
          </div>
          <div class="form-row">
            <div class="col-md-4">
              <base-checkbox class="mb-3" v-model="model.isAvailable">
                {{ $t('Lesson is available to do') }}
              </base-checkbox>
            </div>
          </div>
          <div class="form-row mt-4">
            <div class="col-md-4">
              <base-checkbox class="mb-3" v-model="model.isVisible">
                {{ $t('Show lesson in course') }}
              </base-checkbox>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-4">
              <base-checkbox class="mb-3" v-model="model.isFree">
                {{ $t('Is it free lesson') }}
              </base-checkbox>
            </div>
          </div>
          <base-button
            :loading="loading"
            type="primary"
            native-type="submit">
            {{ $t('Update lesson') }}
          </base-button>
        </form>
      </validation-observer>
    </v-wait>
  </div>
</template>


<script>
  import {createNamespacedHelpers} from 'vuex';
  import {LessonForm} from "../../../mixins/Lesson/LessonForm";
  import {FormEdit, FormNotification, FormSubmitHandlers} from "../../../mixins/FormApiHandlers";
  import MarkdownEditor from "../../../components/Editors/MarkdownEditor";
  import MarkdownPreview from "../../../components/Editors/MarkdownPreview";
  import Spinner from 'vue-spinner-component/src/Spinner';
  import ModalVideosPicker from "../../../components/Modals/ModalVideosPicker";

  import TabPane from '@/components/Tabs/Tab.vue';
  import Tabs from '@/components/Tabs/Tabs.vue';

  const {mapActions, mapState} = createNamespacedHelpers('course/lesson');

  export default {
    name: "FormEditLesson",
    components: {
      ModalVideosPicker, MarkdownEditor, MarkdownPreview, Spinner, Tabs, TabPane
    },
    data() {
      return {
        successMessage: this.$i18n.t('You are update lesson info!'),
        errorMessage: this.$i18n.t('Error on updating lesson info!'),
        submitRedirectTo: {name: 'content', params: this.$route.params},
        waiterKeyword: 'lesson data fetching',
        showVideosPicker: false
      }
    },
    mixins: [LessonForm, FormNotification, FormSubmitHandlers, FormEdit],
    computed: {
      ...mapState({
        vuexModel: state => state.currentLesson,
        status: state => state.updateStatus.status
      }),
      videos() {
        return this.$store.state.course.video.videos
      },
      form() {
        return {
          ...this.model,
          blockId: this.$route.params.blockId
        }
      }
    },
    async created() {
      await this.loadVideos();
    },
    methods: {
      ...mapActions({
        load: 'loadLesson',
        save: 'saveLesson',
        revertStatus: 'revertCreateStatus'
      }),
      async loadVideos() {
        await this.$store.dispatch(
          'course/video/loadVideos',
          {urlParams: this.$route.params});
      },
      videoPicked(videoId) {
        this.model.videoId = videoId
        this.showVideosPicker = false
      },
      loadPreview() {
        this.$refs.preview.getPreview()
      }
    }
  }
</script>

<style lang="scss">
  .nav-pills .nav-link {
    padding: 0!important;
    div > div {
      padding: 0.75rem 1rem;
    }
  }
</style>
